import { render, staticRenderFns } from "./fsrecorditem.vue?vue&type=template&id=3f344e2a&scoped=true"
import script from "./fsrecorditem.vue?vue&type=script&lang=js"
export * from "./fsrecorditem.vue?vue&type=script&lang=js"
import style0 from "./fsrecorditem.vue?vue&type=style&index=0&id=3f344e2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f344e2a",
  null
  
)

export default component.exports